"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SidebarItem = exports.RawSidebarItem = void 0;
var ListItem_1 = __importDefault(require("@mui/material/ListItem"));
var ListItemIcon_1 = __importDefault(require("@mui/material/ListItemIcon"));
var ListItemText_1 = __importDefault(require("@mui/material/ListItemText"));
var React = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
var useStyles = (0, makeStyles_1.default)({
    text: {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
    },
});
var RawSidebarItem = function (_a) {
    var dense = _a.dense, Icon = _a.icon, text = _a.text, onClick = _a.onClick, listItemProps = __rest(_a, ["dense", "icon", "text", "onClick"]);
    var classes = useStyles();
    return (React.createElement(ListItem_1.default, __assign({ onClick: onClick }, listItemProps, { dense: dense, disableGutters: true, button: true }),
        React.createElement(ListItemIcon_1.default, null,
            React.createElement(Icon, { color: listItemProps.selected ? 'primary' : 'inherit' })),
        React.createElement(ListItemText_1.default, { primary: text, classes: { primary: classes.text } })));
};
exports.RawSidebarItem = RawSidebarItem;
var SidebarItem = function (_a) {
    var path = _a.path, external = _a.external, rest = __rest(_a, ["path", "external"]);
    var location = (0, react_router_dom_1.useLocation)();
    var listItemProps = path ? __assign({ selected: (0, react_router_dom_1.matchPath)(location.pathname, path) !== null }, getLinkProps(external, path)) : {};
    return React.createElement(exports.RawSidebarItem, __assign({}, rest, listItemProps));
};
exports.SidebarItem = SidebarItem;
function getLinkProps(external, path) {
    return external ? { component: 'a', target: '_blank', href: path } : { component: react_router_dom_1.Link, to: path, href: '' };
}
